var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrash = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M220 90v150c0 11.046-8.954 20-20 20H80c-11.046 0-20-8.954-20-20V90zm-110 40c-5.43 0-9.848 4.327-9.996 9.72L100 140v70c0 5.523 4.477 10 10 10 5.43 0 9.848-4.327 9.996-9.72L120 210v-70c0-5.523-4.477-10-10-10m60 0c-5.523 0-10 4.477-10 10v70c0 5.523 4.477 10 10 10s10-4.477 10-10v-70c0-5.523-4.477-10-10-10M160 20c5.523 0 10 4.477 10 10v10h60c5.523 0 10 4.477 10 10v10c0 5.523-4.477 10-10 10H50c-5.523 0-10-4.477-10-10V50c0-5.523 4.477-10 10-10h60V30c0-5.523 4.477-10 10-10z"
})));
export default SvgTrash;